import _ from 'underscore';
import { useContext, useCallback } from 'react';

import { convertLegacyContext } from './convert-legacy-context';
import { ServerContextAction, ServerContext } from './server-context';

// This updateServerContextFn should be used for the response from user creation API CustomerAccountUserSignup
export function useUpdateServerContext() {
  const serverContext = useContext(ServerContext);
  const setServerContext = useContext(ServerContextAction);

  const isValidServerContext = useCallback((response) => {
    const isValid = response && response.CurrentAccount && response.CurrentAccount.AccountId
      && response.CurrentCustomer && response.CurrentCustomer.CustomerId
      && response.CurrentUser && response.CurrentUser.UserId
      && response.Token;
    return !!isValid;
  }, []);

  const updateServerContextFn = useCallback((response, logActivity) => {
    if (!isValidServerContext(response) && logActivity && _.functions(logActivity.error)) {
      logActivity.error(`Invalid server context response. response: ${JSON.stringify(_.pick(response, 'CurrentAccount', 'CurrentCustomer', 'CurrentUser', 'Token'))}`);
    }

    const newContext = convertLegacyContext(response);
    const context = {
      ...serverContext,
      ...newContext,
    };

    setServerContext(context);
    if (_.isFunction(_.get(logActivity, 'trace'))) {
      logActivity.trace(`delta newContext: ${JSON.stringify(newContext)}`);
    }

    if (window.seleniumTestContext) {
      window.seleniumTestContext = {
        Token: context.Token,
        CustomerId: context.CurrentCustomer.Id,
        AccountId: context.CurrentAccount.Id,
        AdvertiserCustomerId: context.CurrentAccount.AdvertiserCustomerID,
      };
    }
    return context;
  }, [isValidServerContext, serverContext, setServerContext]);

  return updateServerContextFn;
}
